import { createTheme } from "@mui/material"

export const customTheme = createTheme({
    // typography: {
    //     fontFamily: [
    //         'Poppins'
    //     ].join(','),
    // },
    typography: {
        button: {
            textTransform: 'none'
        }
    },
    // palette: {
    //     primary: {
    //         main: "#0052cc",
    //     },
    //     secondary: {
    //         main: "#edf2ff",
    //     },
    // },
    components: {
        // MuiAppBar: {
        //     styleOverrides: {
        //         colorPrimary: {
        //             backgroundColor: "#ffffff",
        //             color: "#454545",
        //             boxShadow: "0 4px 2px -1px  #0000000F",
        //             height: "80",
        //         },
        //     },
        // },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    // width: "256px",
                    padding: "8px 10px",
                    // border: "1px solid red",
                    // display: "flex",
                    // flexDirection: "column",
                    // alignItems: "center",
                    // justifyContent: "center",
                    margin: "0",
                    "&:hover": {
                        backgroundColor: 'transparent',
                    },
                    "&& .Mui-selected": {
                        backgroundColor: 'transparent',
                    }
                },
            },
            defaultProps: {
                disableRipple: true
            }
        },
        // MuiDrawer: {
        //     styleOverrides: {},
        // },
    },
})